module.exports = __webpack_public_path__ + "static/media/JD.c38f31dc.svg";